import { dummyGuestTeam, dummyHomeTeam, Team } from '../lib/Team';

// TODO: fetch teams from firebase/nuliga
const teams : Team[] = [
  dummyHomeTeam,
  dummyGuestTeam,
  { name: '1. AC Bayreuth', iconUrl: '/club_icons/1. AC Bayreuth.png' },
  { name: '1. BC Selb', iconUrl: '/club_icons/1. BC Selb.png' },
  { name: '1. BSDV Rosenheim', iconUrl: '/club_icons/1. BSDV Rosenheim.png' },
  { name: '1. BSV Schweinfurt', iconUrl: '/club_icons/1. BSV Schweinfurt.png' },
  { name: '1. BV Triangel Weissenburg', iconUrl: '/club_icons/1. BV Triangel Weissenburg.png' },
  { name: '1. Muenchner Snooker Club', iconUrl: '/club_icons/1. Muenchner Snooker Club.png' },
  { name: '1. PBC Arnstorf', iconUrl: '/club_icons/1. PBC Arnstorf.png' },
  { name: '1. PBC Aschaffenburg-Damm', iconUrl: '/club_icons/1. PBC Aschaffenburg-Damm.png' },
  { name: '1. PBC Klingenberg', iconUrl: '/club_icons/1. PBC Klingenberg.png' },
  { name: '1. PBC Koenigsbrunn', iconUrl: '/club_icons/1. PBC Koenigsbrunn.png' },
  { name: '1. PBC Memmingen', iconUrl: '/club_icons/1. PBC Memmingen.png' },
  { name: '1. PBC Passau', iconUrl: '/club_icons/1. PBC Passau.png' },
  { name: '1. PBC Pfaffenberg', iconUrl: '/club_icons/1. PBC Pfaffenberg.png' },
  { name: '1. PBC Simbach', iconUrl: '/club_icons/1. PBC Simbach.png' },
  { name: '1. PBC Sonthofen', iconUrl: '/club_icons/1. PBC Sonthofen.png' },
  { name: '1. PBC Teuflische 8 Moosburg', iconUrl: '/club_icons/1. PBC Teuflische 8 Moosburg.png' },
  { name: '1. PBC Traunstein', iconUrl: '/club_icons/1. PBC Traunstein.png' },
  { name: '1. PBV Amberg', iconUrl: '/club_icons/1. PBV Amberg.png' },
  { name: 'ABC Bamberg', iconUrl: '/club_icons/ABC Bamberg.png' },
  { name: 'AS Steadtedreieck', iconUrl: '/club_icons/AS Steadtedreieck.png' },
  { name: 'ATSV Erlangen', iconUrl: '/club_icons/ATSV Erlangen.png' },
  { name: 'BAD Siegenburg', iconUrl: '/club_icons/BAD Siegenburg.png' },
  { name: 'BBV', iconUrl: '/club_icons/BBV.png' },
  { name: 'BC 1992 Haunstetten', iconUrl: '/club_icons/BC 1992 Haunstetten.png' },
  { name: 'BC 73 Pfeffenhausen', iconUrl: '/club_icons/BC 73 Pfeffenhausen.png' },
  { name: 'BC 80 Wildenberg', iconUrl: '/club_icons/BC 80 Wildenberg.png' },
  { name: 'BC 93 Neumarkt', iconUrl: '/club_icons/BC 93 Neumarkt.png' },
  { name: 'BC 97 Herzogenaurach', iconUrl: '/club_icons/BC 97 Herzogenaurach.png' },
  { name: 'BC H18 Muenchen', iconUrl: '/club_icons/BC H18 Muenchen.png' },
  { name: 'BC Karlstein', iconUrl: '/club_icons/BC Karlstein.png' },
  { name: 'BC Kehlheim', iconUrl: '/club_icons/BC Kehlheim.png' },
  { name: 'BC Kempten', iconUrl: '/club_icons/BC Kempten.png' },
  { name: 'BC Landau', iconUrl: '/club_icons/BC Landau.png' },
  { name: 'BC Mainburg', iconUrl: '/club_icons/BC Mainburg.png' },
  { name: 'BC Neu-Ulm', iconUrl: '/club_icons/BC Neu-Ulm.png' },
  { name: 'BC Osterhofen', iconUrl: '/club_icons/BC Osterhofen.png' },
  { name: 'BC Regensburg', iconUrl: '/club_icons/BC Regensburg.png' },
  { name: 'BC Rockets Regensburg', iconUrl: '/club_icons/BC Rockets Regensburg.png' },
  { name: 'BC Royal Flair', iconUrl: '/club_icons/BC Royal Flair.png' },
  { name: 'BC Sindelfingen', iconUrl: '/club_icons/BC Sindelfingen.png' },
  { name: 'BC Spitzwegwinkel Straubing', iconUrl: '/club_icons/BC Spitzwegwinkel Straubing.png' },
  { name: 'BC Tutzing', iconUrl: '/club_icons/BC Tutzing.png' },
  { name: 'Billard Carambol Club Muenchen', iconUrl: '/club_icons/Billard Carambol Club Muenchen.png' },
  { name: 'Billardfreunde Creidlitz-Coburg', iconUrl: '/club_icons/Billardfreunde Creidlitz-Coburg.png' },
  { name: 'Billardfreunde Muehlhausen', iconUrl: '/club_icons/Billardfreunde Muehlhausen.png' },
  { name: 'BSC Ingolstadt', iconUrl: '/club_icons/BSC Ingolstadt.png' },
  { name: 'BSC Kissing', iconUrl: '/club_icons/BSC Kissing.png' },
  { name: 'BSC Martinsried', iconUrl: '/club_icons/BSC Martinsried.png' },
  { name: 'BSC Pfaffenhofen', iconUrl: '/club_icons/BSC Pfaffenhofen.png' },
  { name: 'BSC Plattling', iconUrl: '/club_icons/BSC Plattling.png' },
  { name: 'BSV 1912 Muenchen', iconUrl: '/club_icons/BSV 1912 Muenchen.png' },
  { name: 'BSV Dachau', iconUrl: '/club_icons/BSV Dachau.png' },
  { name: 'BSV Ergolding', iconUrl: '/club_icons/BSV Ergolding.png' },
  { name: 'BSV Pegnitz', iconUrl: '/club_icons/BSV Pegnitz.png' },
  { name: 'BSV Pfaffenhofen', iconUrl: '/club_icons/BSV Pfaffenhofen.png' },
  { name: 'BSV Playhouse FFB', iconUrl: '/club_icons/BSV Playhouse FFB.png' },
  { name: 'BSV Poolbrothers Muenchen', iconUrl: '/club_icons/BSV Poolbrothers Muenchen.png' },
  { name: 'BV Fortuna Straubing', iconUrl: '/club_icons/BV Fortuna Straubing.png' },
  { name: 'BV Pool Dragons GAP', iconUrl: '/club_icons/BV Pool Dragons GAP.png' },
  { name: 'BV Q-Club', iconUrl: '/club_icons/BV Q-Club.png' },
  { name: 'BV Schierstein', iconUrl: '/club_icons/BV Schierstein.png' },
  { name: 'BV Schoellkrippen', iconUrl: '/club_icons/BV Schoellkrippen.png' },
  { name: 'CSC Regensburg', iconUrl: '/club_icons/CSC Regensburg.png' },
  { name: 'Magic 8 Hof', iconUrl: '/club_icons/Magic 8 Hof.png' },
  { name: 'Mannheimer Billardfreunde', iconUrl: '/club_icons/Mannheimer Billardfreunde.png' },
  { name: 'PB Deggendorf', iconUrl: '/club_icons/PB Deggendorf.png' },
  { name: 'PBC Black Eight Munich', iconUrl: '/club_icons/PBC Black Eight Munich.png' },
  { name: 'PBC Blau Weiß Burgkirchen Alz', iconUrl: '/club_icons/PBC Blau Weiss Burgkirchen Alz.png' },
  { name: 'PBC College Markt Schwaben', iconUrl: '/club_icons/PBC College Markt Schwaben.png' },
  { name: 'PBC Erding', iconUrl: '/club_icons/PBC Erding.png' },
  { name: 'PBC Freising', iconUrl: '/club_icons/PBC Freising.png' },
  { name: 'PBC Hoasse Greim', iconUrl: '/club_icons/PBC Hoasse Greim.png' },
  { name: 'PBC Ilmuenster', iconUrl: '/club_icons/PBC Ilmuenster.png' },
  { name: 'PBC Joker 89 Altstadt', iconUrl: '/club_icons/PBC Joker 89 Altstadt.png' },
  { name: 'PBC Muehldorf', iconUrl: '/club_icons/PBC Muehldorf.png' },
  { name: 'PBC Regensburg', iconUrl: '/club_icons/PBC Regensburg.png' },
  { name: 'PBC Red Lion', iconUrl: '/club_icons/PBC Red Lion.png' },
  { name: 'PBSC Donauwoerth', iconUrl: '/club_icons/PBSC Donauwoerth.png' },
  { name: 'PBT Muenchsmuenster', iconUrl: '/club_icons/PBT Muenchsmuenster.png' },
  { name: 'PBV Kiss Shot Schwandorf', iconUrl: '/club_icons/PBV Kiss Shot Schwandorf.png' },
  { name: 'Pool Factory Roth', iconUrl: '/club_icons/Pool Factory Roth.png' },
  { name: 'PSV Wuerzburg', iconUrl: '/club_icons/PSV Wuerzburg.png' },
  { name: 'PTSV Hof', iconUrl: '/club_icons/PTSV Hof.png' },
  { name: 'SC 147 Muenchen', iconUrl: '/club_icons/SC 147 Muenchen.png' },
  { name: 'SC Dingolfing', iconUrl: '/club_icons/SC Dingolfing.png' },
  { name: 'SC Teublitz', iconUrl: '/club_icons/SC Teublitz.png' },
  { name: 'SG Joker Straubing', iconUrl: '/club_icons/SG Joker Straubing.png' },
  { name: 'SP Regensburg', iconUrl: '/club_icons/SP Regensburg.png' },
  { name: 'SSC Fuerth', iconUrl: '/club_icons/SSC Fuerth.png' },
  { name: 'SV Voetting Weihenstephan', iconUrl: '/club_icons/SV Voetting Weihenstephan.png' },
  { name: 'TSV 1882 Landsberg', iconUrl: '/club_icons/TSV 1882 Landsberg.png' },
  { name: 'TSV Burgebrach', iconUrl: '/club_icons/TSV Burgebrach.png' },
  { name: 'TSV Ingolstadt', iconUrl: '/club_icons/TSV Ingolstadt.png' },
  { name: 'TV Cannstatt', iconUrl: '/club_icons/TV Cannstatt.png' },
  { name: 'TV Schweinheim', iconUrl: '/club_icons/TV Schweinheim.png' },
  { name: 'United Snooker Club Ingolstadt', iconUrl: '/club_icons/United Snooker Club Ingolstadt.png' },
  { name: 'NBY', iconUrl: '/club_icons/Bayern.png' },
  { name: 'Tirol', iconUrl: '/club_icons/Tirol.png' },
];

export default function useTeams() {
  return teams;
}
